module.exports = __webpack_public_path__ + "media/Components/Logos/icon-tool-centervertical-f7034c9f6c6e0f1c430e747e8561d441.svg";